import { ClientAgentApi } from './clientagent-api';
import {
  InputCreateTempPurchaseOrderQuote,
  InputGenerateReport,
  InputIssuePurchaseOrder,
  InputIssueQuote,
  InputPreviewQuoteShopDrawing,
  InputResetQuoteFromIssuePending,
  ResultCreateTempPurchaseOrderQuote,
  ResultVoid
} from './dealer-api-interface-clientagent';
import type { ApiCommunications, NullPromise } from '../../webmodule-common/interop/webmodule-interop';

export class DealerClientAgentApi implements ClientAgentApi {
  apiPath = 'api/Queue/';

  api: ApiCommunications;

  constructor(api: ApiCommunications) {
    this.api = api;
  }

  async previewQuoteShopDrawing(input: InputPreviewQuoteShopDrawing): NullPromise<ResultVoid> {
    return await this.api.post<ResultVoid>(`${this.apiPath}PreviewQuoteShopDrawing`, input);
  }
  async createSupplierQuote(input: InputCreateTempPurchaseOrderQuote): NullPromise<ResultCreateTempPurchaseOrderQuote> {
    return await this.api.post<ResultCreateTempPurchaseOrderQuote>(`${this.apiPath}CreateSupplierQuote`, input);
  }
  async issueQuote(input: InputIssueQuote): NullPromise<ResultVoid> {
    return await this.api.post<ResultVoid>(`${this.apiPath}IssueQuote`, input);
  }

  async issuePurchaseOrder(input: InputIssuePurchaseOrder): NullPromise<ResultVoid> {
    return await this.api.post<ResultVoid>(`${this.apiPath}IssuePurchaseOrder`, input);
  }

  async generateReport(input: InputGenerateReport): NullPromise<ResultVoid> {
    return await this.api.post<ResultVoid>(`${this.apiPath}GenerateReport`, input);
  }

  async resetQuoteFromIssuePending(input: InputResetQuoteFromIssuePending): NullPromise<ResultVoid> {
    return await this.api.post<ResultVoid>(`${this.apiPath}ResetQuoteFromIssuePending`, input);
  }
}
